export default __webpack_public_path__ + "static/media/SE.632f7cc4.svg";